import { GIFT_TYPES } from '../../constants';
import { useI18n } from '@ywwwtseng/react-kit';
import { Typography } from '@ywwwtseng/tma-react-kit';
import { ChevronDown } from 'lucide-react';
import { Select } from '@/components/ui/Select';

export function SelectGiftType({
  value,
  onChange,
}: {
  value: GIFT_TYPES;
  onChange: (value: GIFT_TYPES) => void;
}) {
  const { t } = useI18n();

  const options = Object.values(GIFT_TYPES)
    .map((type) => ({
      key: type,
      name: t(`gift_type.${type}`),
    }))
    .filter((item) => item.key !== GIFT_TYPES.SHARE);

  return (
    <Select
      options={options}
      value={value}
      onChange={(key) => {
        onChange(key as GIFT_TYPES);
      }}
      trigger={
        <div className="flex items-center justify-between gap-1 pl-2 pr-3 rounded-lg text-sm">
          <Typography size="2" className="text-[#b8860b]">{t(`gift_type.${value}`)}</Typography>
          <ChevronDown width={20} height={20} className="text-[#b8860b]" />
        </div>
      }
    />
  );
}
